import { ISlotsStatePersisted } from 'features/slots/types'

type ReturnMigrationType = (state: ISlotsStatePersisted) => ISlotsStatePersisted

export const slotsMigrations: Record<string, ReturnMigrationType> = {
  1: state => ({
    ...state,
    data: {
      ...state.data,
      gameList: [],
      externalGames: {
        top: {
          lastLoadDate: null,
          games: [],
        },
        new: {
          lastLoadDate: null,
          games: [],
        },
        categories: {
          lastLoadDate: null,
          categoriesData: {},
        },
        wager: {
          lastLoadDate: null,
          games: [],
        },
      },
    },
  }),
  2: state => ({
    ...state,
    data: {
      ...state.data,
      gameList: [],
      externalGames: {
        top: {
          lastLoadDate: null,
          games: [],
        },
        new: {
          lastLoadDate: null,
          games: [],
        },
        categories: {
          lastLoadDate: null,
          categoriesData: {},
        },
        wager: {
          lastLoadDate: null,
          games: [],
        },
      },
    },
  }),
}
